import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = 'authToken';

export const setToken = async (token: string): Promise<void> => {
  await Preferences.set({ key: TOKEN_KEY, value: token });
};

export const getToken = async (): Promise<string | null> => {
  const result = await Preferences.get({ key: TOKEN_KEY });
  return result.value;
};

export const removeToken = async (): Promise<void> => {
  await Preferences.remove({ key: TOKEN_KEY });
};
